import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

import {
  getServices,
  getService,
  createService,
  updateService,
  deleteService,
} from "@/lib/api/services";
import type { ServiceRequest } from "@/types/service";

export const useServicesQuery = () =>
  useQuery({
    queryKey: ["services"],
    queryFn: getServices,
  });

export const useServiceQuery = (id: string) =>
  useQuery({
    queryKey: ["service", id],
    queryFn: () => getService(id).then((res) => res.data),
    enabled: !!id,
  });

export const useCreateServiceMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createService,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["services"] });
    },
  });
};

export const useUpdateServiceMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: ServiceRequest }) =>
      updateService(id, data),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["services"] });
      queryClient.invalidateQueries({ queryKey: ["service", variables.id] });
    },
  });
};

export const useDeleteServiceMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteService,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["services"] });
    },
  });
};
